import { ROUTES } from "../shared/constants/routes";

export enum ANALYTICS_EVENT {
  SCREEN_VIEW = "screen_view",
  SCREEN_TIME = "screen_time",
  INTERACTION = "interaction",
  DEEPLINK_OPENED = "deeplink_opened",
  APP_INSTALLED = "app_installed",
  SESSION_START = "session_start",
}

export enum ACTION_TYPE {
  CLICK = "click",
  SWIPE = "swipe",
}

export enum DIRECTION {
  LEFT = "LEFT",
  RIGHT = "RIGHT",
  DOWN = "DOWN",
  UP = "UP"
}
export type BaseAnalyticsPayload = {
  event: ANALYTICS_EVENT;
  screen_name: ROUTES | "BOTTOM_MODAL" | "ONBOARDING";
  context?: TrackingContext;
};

export type InteractionPayload = BaseAnalyticsPayload & {
  event: ANALYTICS_EVENT.INTERACTION;
  action: ACTION_TYPE;
  component?: string;
  direction?: DIRECTION;
};

export type DeeplinkPayload = BaseAnalyticsPayload & {
  event: ANALYTICS_EVENT.DEEPLINK_OPENED;
  deeplink_url: string;
};


export type TrackingContext = {
  cta?: string;
  [key: string]: string | number | boolean | undefined;
};
